import { render, staticRenderFns } from "./CompanyFinancialRatios.vue?vue&type=template&id=302c40fa&"
import script from "./CompanyFinancialRatios.vue?vue&type=script&lang=ts&"
export * from "./CompanyFinancialRatios.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports